/* Immer relies on these 'dirty' tricks: https://redux-toolkit.js.org/api/createSlice#examples
 * note that "state" is already a draft of the original state and meant to be reassigned */
import { createSlice } from '@reduxjs/toolkit';
import {
  fulfilled,
  initialRequestState,
  pending,
  rejected,
  requestReducer,
} from 'features/shared/request';
import {
  getAllAutomatedNoteSchedulesByReportLevelAndParentId,
  getDashboardDatasetConfigsByReportLevelAndParentId,
} from './async';
import { AutomatedNoteSchedulesState } from './types';

export const initialState: AutomatedNoteSchedulesState = {
  automatedNoteSchedulesForCampaign: {
    data: undefined,
    request: initialRequestState,
  },
  dashboardDatasetConfigsForCampaign: {
    data: undefined,
    request: initialRequestState,
  },
};

const slice = createSlice({
  name: 'automatedNoteSchedules',
  initialState,
  reducers: {
    resetCampaignAutomatedNoteSchedules(state) {
      state.automatedNoteSchedulesForCampaign = {
        data: undefined,
        request: initialRequestState,
      };
      state.dashboardDatasetConfigsForCampaign = {
        data: undefined,
        request: initialRequestState,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAllAutomatedNoteSchedulesByReportLevelAndParentId.fulfilled,
      (state, { meta, payload }) => {
        if (
          state.automatedNoteSchedulesForCampaign.request.id === meta.requestId
        ) {
          state.automatedNoteSchedulesForCampaign.data = payload;
          state.automatedNoteSchedulesForCampaign.request = requestReducer(
            state.automatedNoteSchedulesForCampaign.request,
            fulfilled({ meta })
          );
        }
      }
    );

    builder.addCase(
      getAllAutomatedNoteSchedulesByReportLevelAndParentId.pending,
      (state, { meta }) => {
        state.automatedNoteSchedulesForCampaign.data = undefined;
        state.automatedNoteSchedulesForCampaign.request = requestReducer(
          state.automatedNoteSchedulesForCampaign.request,
          pending({ meta })
        );
      }
    );

    builder.addCase(
      getAllAutomatedNoteSchedulesByReportLevelAndParentId.rejected,
      (state, { meta }) => {
        state.automatedNoteSchedulesForCampaign.data = undefined;
        state.automatedNoteSchedulesForCampaign.request = requestReducer(
          state.automatedNoteSchedulesForCampaign.request,
          rejected({ meta })
        );
      }
    );

    builder.addCase(
      getDashboardDatasetConfigsByReportLevelAndParentId.fulfilled,
      (state, { meta, payload }) => {
        if (
          state.dashboardDatasetConfigsForCampaign.request.id === meta.requestId
        ) {
          state.dashboardDatasetConfigsForCampaign.data = payload;
          state.dashboardDatasetConfigsForCampaign.request = requestReducer(
            state.dashboardDatasetConfigsForCampaign.request,
            fulfilled({ meta })
          );
        }
      }
    );

    builder.addCase(
      getDashboardDatasetConfigsByReportLevelAndParentId.pending,
      (state, { meta }) => {
        state.dashboardDatasetConfigsForCampaign.data = undefined;
        state.dashboardDatasetConfigsForCampaign.request = requestReducer(
          state.dashboardDatasetConfigsForCampaign.request,
          pending({ meta })
        );
      }
    );

    builder.addCase(
      getDashboardDatasetConfigsByReportLevelAndParentId.rejected,
      (state, { meta }) => {
        state.dashboardDatasetConfigsForCampaign.data = undefined;
        state.dashboardDatasetConfigsForCampaign.request = requestReducer(
          state.dashboardDatasetConfigsForCampaign.request,
          rejected({ meta })
        );
      }
    );
  },
});

export const { resetCampaignAutomatedNoteSchedules } = slice.actions;

const { reducer } = slice;

export default reducer;
